export default "__VITE_ASSET__CE$_eltK__"